import { TextFieldRoot, TextFieldLabel } from "@/components/shadcn/textfield";

import {
  Combobox,
} from "../Combobox";
import { cn } from "@/libs/cn";

export function SelectInput(props) {

  const onInput = (item) => {
    props.input(props.name, item);
  }

  const value = () => {
    return props.value || props.form[props.name];
  }

  return (
    <TextFieldRoot class={cn("space-y-0", props.class)}>
      <TextFieldLabel class={props.sr ? 'sr-only mb-1' : ''}>{props.label}</TextFieldLabel>
      <Combobox
        class={props.inputClass}
        value={value()}
        onChange={onInput}
        options={props.options}
      />
    </TextFieldRoot>
  );
}
